export { default as routes } from './routes'



// WEBPACK FOOTER //
// ./src/app/domains/institution_unit/index.js